var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateCabalGroupMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 112,
    viewBox: "0 0 102 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.549475,
    y: 10.0495,
    width: 100.891,
    height: 100.9,
    rx: 50.4453,
    fill: "#212327"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.549475,
    y: 10.0495,
    width: 100.891,
    height: 100.9,
    rx: 50.4453,
    stroke: "#0B0B0B",
    strokeWidth: 1.09895
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4258 30.9255C28.0367 31.0043 27.1853 31.3146 26.534 31.6148C25.8825 31.9152 25.2512 32.1802 25.1312 32.2038C24.8797 32.2533 23.9392 33.0234 23.2323 33.7581C22.9659 34.0352 22.4109 34.9368 21.9989 35.762C21.2708 37.2208 21.25 37.3242 21.25 39.4951C21.25 41.8791 21.3935 42.4065 22.6118 44.5018C22.9225 45.0362 23.1157 45.5715 23.0411 45.6916C22.9667 45.8117 22.99 45.8581 23.0931 45.7946C23.26 45.6918 26.2999 50.7911 26.1586 50.9366C26.1271 50.9688 26.2831 51.1937 26.5055 51.4363C26.7278 51.6787 27.2281 52.4925 27.6172 53.2449C28.0063 53.9973 28.4062 54.6717 28.5058 54.7436C28.6053 54.8155 28.6291 55.0243 28.5586 55.2074C28.4872 55.393 28.5143 55.4887 28.62 55.4236C28.8414 55.2874 29.2816 56.0096 29.0924 56.1984C29.0223 56.2683 29.0619 56.3255 29.1807 56.3255C29.4373 56.3255 30.245 57.6338 30.245 58.0497C30.245 58.2097 30.3153 58.3405 30.4012 58.3405C30.4871 58.3405 30.7354 58.6806 30.9531 59.0961C31.1706 59.5118 31.6915 60.4199 32.1107 61.1147C32.5297 61.8092 32.8727 62.4232 32.8727 62.479C32.8727 62.5348 33.0945 62.9187 33.3657 63.3317C33.6368 63.745 33.887 64.2191 33.9216 64.3853C33.9562 64.5516 34.0397 64.7329 34.107 64.7883C34.2766 64.928 35.7376 67.3556 36.1683 68.2137C36.363 68.6016 36.6082 69.055 36.7131 69.2212C37.2215 70.0266 38.5325 72.2588 38.5325 72.319C38.5325 72.3567 39 73.1937 39.5715 74.1794C40.1429 75.1649 40.8122 76.334 41.059 76.7773C41.3058 77.2206 41.9372 78.3276 42.4626 79.2375C42.9879 80.1473 43.3578 80.9883 43.2847 81.1064C43.2115 81.2243 43.2546 81.296 43.3803 81.2656C43.506 81.2352 43.8393 81.6182 44.1207 82.1169C44.4021 82.6156 44.7607 83.2245 44.9177 83.4699C45.0746 83.7154 45.2029 84.0553 45.2029 84.2255C45.2029 84.3956 45.2747 84.5348 45.3626 84.5348C45.4503 84.5348 45.8823 85.1776 46.3228 85.9634C46.763 86.7491 47.3405 87.7769 47.6063 88.2476C47.8719 88.7181 48.3431 89.273 48.6532 89.4807C48.9632 89.6885 49.1842 89.9113 49.1441 89.9758C49.0502 90.1275 50.1029 90.2613 51.293 90.2488C52.4317 90.2367 53.2861 89.6873 53.9232 88.5571C54.1708 88.118 54.4476 87.7588 54.5383 87.7588C54.6291 87.7588 54.6885 87.6908 54.6707 87.6076C54.6343 87.4394 54.9961 86.6131 55.3101 86.1468C55.422 85.9806 56.1354 84.7796 56.8954 83.4784C57.6552 82.1769 58.3516 81.1795 58.4427 81.2619C58.5341 81.3442 58.5379 81.2898 58.4514 81.1407C58.3562 80.9768 58.4634 80.6415 58.7221 80.2924C58.9576 79.975 59.1502 79.6756 59.1502 79.627C59.1502 79.5785 59.5223 78.9278 59.9773 78.1815C60.968 76.556 61.4489 75.7245 62.2323 74.282C63.2788 72.3553 63.9216 71.4256 64.097 71.5846C64.1912 71.67 64.2026 71.6259 64.1221 71.4866C64.0412 71.3468 64.1625 70.972 64.393 70.6496C64.6224 70.3284 64.81 70.0216 64.81 69.9678C64.81 69.914 65.6286 68.4948 66.6292 66.8144C67.6297 65.1339 68.4484 63.6902 68.4484 63.6064C68.4484 63.5225 68.6127 63.2781 68.8134 63.0633C69.0142 62.8483 69.2007 62.582 69.2278 62.4711C69.3732 61.8761 72.4438 56.9476 72.5877 57.0779C72.6813 57.1628 72.7017 57.1337 72.633 57.0132C72.5643 56.8927 72.8681 56.1801 73.3081 55.4293C73.7481 54.6785 74.1082 54.0323 74.1082 53.993C74.1082 53.9539 74.6084 53.0994 75.2199 52.0941C75.8313 51.0889 76.3316 50.2315 76.3316 50.1888C76.3316 50.1461 76.7864 49.3802 77.3423 48.4868C77.8982 47.5933 78.353 46.8238 78.353 46.7771C78.353 46.7301 78.8078 45.9213 79.3636 44.98C79.9195 44.0384 80.3743 43.1179 80.3743 42.9342C80.3743 42.7504 80.4459 42.6442 80.5334 42.698C80.6209 42.752 80.7133 41.7826 80.739 40.5438C80.7794 38.5835 80.7206 38.1112 80.2844 36.898C80.0089 36.1313 79.7024 35.4513 79.6038 35.3868C79.5049 35.3221 79.3093 35.0523 79.169 34.7869C78.6269 33.7615 77.2325 32.5058 75.9963 31.9295C73.3162 30.6807 74.4556 30.7335 50.7697 30.7588C38.8696 30.7715 28.8149 30.8465 28.4258 30.9255ZM47.6285 55.7174C47.6285 65.9151 47.5917 74.2586 47.5467 74.2586C47.4517 74.2586 45.5203 71.0081 45.4817 70.7828C45.4673 70.6996 45.4334 70.5638 45.4065 70.4806C45.3794 70.3973 45.3703 70.2547 45.3861 70.1634C45.402 70.0719 45.3355 70.0461 45.2383 70.1062C45.1413 70.166 44.9353 69.9688 44.7807 69.6677C44.626 69.3667 44.2359 68.6671 43.9137 68.113C41.7693 64.4258 39.7453 60.8989 39.7453 60.8491C39.7453 60.8169 39.2873 60.0542 38.7276 59.1545C38.1604 58.243 37.7721 57.4108 37.8503 57.2748C37.9277 57.1406 37.9162 57.0983 37.825 57.1807C37.7337 57.2631 37.5598 57.1559 37.4387 56.9423C36.7343 55.6997 35.3331 53.2662 34.1254 51.1874C33.6748 50.4117 33.2768 49.6413 33.241 49.4755C33.2052 49.3097 33.066 49.083 32.9316 48.9718C32.7973 48.8605 32.1717 47.8627 31.5415 46.7545C30.9112 45.6463 30.2296 44.4676 30.0267 44.1351C28.8695 42.2388 27.6172 39.7979 27.6172 39.4384C27.6172 38.6842 27.9793 38.0558 28.6619 37.6246C29.3208 37.2083 29.5325 37.1988 38.482 37.1877L47.6285 37.1763V55.7174ZM73.3152 38.1755C73.8122 38.6709 73.906 38.926 73.906 39.7826C73.906 40.7423 73.3259 42.1798 73.0496 41.9045C72.9869 41.8421 72.9495 41.9126 72.9661 42.0611C73.0075 42.4298 68.996 49.2607 68.8066 49.1441C68.7233 49.0927 68.7015 49.1713 68.7583 49.3186C68.8149 49.4658 68.6319 49.896 68.3516 50.2748C68.0714 50.6537 67.842 51.0262 67.842 51.1032C67.842 51.4044 65.6789 54.9102 65.5518 54.8149C65.4772 54.7591 65.4582 54.7704 65.5096 54.8401C65.5607 54.9096 65.3897 55.3402 65.1295 55.7972C64.5027 56.8972 62.8272 59.7723 62.5903 60.1539C62.4872 60.3202 61.7019 61.6803 60.8453 63.1764C57.75 68.5825 56.8732 70.0272 56.6876 70.0272C56.5837 70.0272 56.5405 70.0951 56.5918 70.1783C56.6431 70.2615 56.4671 70.6921 56.2009 71.1354C55.9344 71.5787 55.6531 72.0774 55.5753 72.2436C55.4974 72.4099 55.1332 73.0446 54.7659 73.6541L54.0979 74.7623L54.0975 56.1744L54.0968 37.5865H63.4106H72.7243L73.3152 38.1755Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.549475,
    y: 1.04947,
    width: 100.891,
    height: 100.9,
    rx: 50.4453,
    fill: "#373C44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.549475,
    y: 1.04947,
    width: 100.891,
    height: 100.9,
    rx: 50.4453,
    stroke: "#0B0B0B",
    strokeWidth: 1.09895
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2948 45.0848C32.1888 45.0848 32.6505 44.5751 34.0828 45.5466C36.3657 47.0518 37.1427 50.0152 37.1427 51.9093C37.1427 55.6977 33.7676 60.3607 30.0764 60.3607C26.41 60.3607 23.7631 56.1355 23.4718 52.4679V52.4439C23.4718 52.2743 23.4718 52.0798 23.4718 51.9093C23.4718 48.1441 26.5308 45.0848 30.2948 45.0848ZM26.8221 62.8606C28.74 64.7788 31.8727 64.7788 33.7667 62.8606L35.0534 61.5978H35.9271C38.2828 61.5978 38.8653 61.0393 40.2248 62.0836C42.022 63.4432 42.4349 65.7991 42.4349 67.4748V74.6146H37.1409H23.5917H18.177L17.1328 73.0605L18.177 67.4748C18.93 63.492 20.6295 61.5978 24.6848 61.5978H25.5586L26.8221 62.8606Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3911 73.0605L42.4353 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0981 73.0605L37.1424 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1338 73.0605L18.178 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6414 60.043H24.5152L25.7778 61.3297C27.6958 63.2479 30.8285 63.2479 32.7225 61.3297L34.0091 60.043H34.8829C38.9381 60.043 41.3907 61.8883 41.3907 65.944V73.0589H17.1328V65.944C17.1337 61.8883 19.5862 60.043 23.6414 60.043Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2502 43.5293C25.4862 43.5293 22.4272 46.5894 22.4272 50.3778C22.4272 54.1422 25.4871 59.0477 29.2502 59.0477C33.0382 59.0477 36.0981 54.1422 36.0981 50.3778C36.0981 46.5894 33.0382 43.5293 29.2502 43.5293Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4272 50.9135C26.5065 50.7918 29.2502 50.4766 32.1156 47.6597C32.1156 47.6597 33.1599 49.6507 36.0981 50.3797C36.0981 46.5914 33.0382 43.5312 29.2502 43.5312C25.4862 43.5312 22.4272 46.5914 22.4272 50.3797C22.4272 50.5494 22.4272 50.743 22.4272 50.9135Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0981 73.0622V66.4082",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0981 50.3789C36.0981 50.3789 37.0456 51.9578 36.9967 53.3662",
    stroke: "black",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0982 50.3776C36.0982 50.3776 37.0456 51.9565 36.9967 53.3649C37.0935 52.8792 37.1424 52.3934 37.1424 51.9077C37.1424 50.0135 36.3654 47.051 34.0825 45.5449C35.3212 46.7837 36.0982 48.4834 36.0982 50.3776Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2568 73.0622V66.4082",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2568 73.0605L23.325 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9145 45.0848C73.7845 45.0848 74.2453 44.5751 75.7024 45.5466C77.9605 47.0518 78.7623 50.0152 78.7623 51.9093C78.7623 55.6977 75.3872 60.3607 71.696 60.3607C68.0048 60.3607 65.3587 56.1355 65.0914 52.4679V52.4439C65.0675 52.2743 65.0675 52.0798 65.0675 51.9093C65.0666 48.1441 68.1265 45.0848 71.9145 45.0848ZM68.4417 62.8606C70.3597 64.7788 73.4684 64.7788 75.3863 62.8606L76.649 61.5978H77.5228C79.8785 61.5978 80.461 61.0393 81.8453 62.0836C83.6425 63.4432 84.0305 65.7991 84.0305 67.4748V74.6146H78.7366H65.1874H59.7967L58.7524 73.0605L59.7967 67.4748C60.5248 63.492 62.2492 61.5978 66.3044 61.5978H67.1542L68.4417 62.8606Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9868 73.0605L84.031 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6934 73.0605L78.7376 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7534 73.0605L59.7976 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2611 60.043H66.1108L67.3975 61.3297C69.3155 63.2479 72.4241 63.2479 74.3421 61.3297L75.6048 60.043H76.4785C80.5338 60.043 82.9863 61.8883 82.9863 65.944V73.0589H58.7524V65.944C58.7533 61.8883 61.1818 60.043 65.2611 60.043Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8703 43.5293C67.0823 43.5293 64.0225 46.5894 64.0225 50.3778C64.0225 54.1422 67.0823 59.0477 70.8703 59.0477C74.6343 59.0477 77.6933 54.1422 77.6933 50.3778C77.6933 46.5894 74.6343 43.5293 70.8703 43.5293Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0463 50.9135C68.1016 50.7918 70.8453 50.4766 73.7347 47.6597C73.7347 47.6597 74.755 49.6507 77.6923 50.3797C77.6923 46.5914 74.6325 43.5312 70.8693 43.5312C67.0813 43.5312 64.0215 46.5914 64.0215 50.3797C64.0223 50.5494 64.0223 50.743 64.0463 50.9135Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6934 73.0622V66.4082",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6934 50.3789C77.6934 50.3789 78.6648 51.9578 78.592 53.3662",
    stroke: "black",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6928 50.3776C77.6928 50.3776 78.6642 51.9565 78.5914 53.3649C78.6882 52.8792 78.761 52.3934 78.761 51.9077C78.761 50.0135 77.9601 47.051 75.7012 45.5449C76.9398 46.7837 77.6928 48.4834 77.6928 50.3776Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M63.877 73.0622V66.4082",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.877 73.0605L64.9212 74.6146",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.263 59.8244C50.6667 62.2283 54.6003 62.2283 57.0049 59.8244L58.5836 58.2455H59.6767C62.6637 58.2455 63.3679 57.5412 65.0914 58.8528C67.3495 60.5774 67.86 63.5159 67.86 65.6285V74.5897H61.2306H44.1847H37.4096L36.0981 72.6467L37.4096 65.6285C38.3571 60.6262 40.4935 58.2463 45.5681 58.2463H46.6851L48.263 59.8244Z",
    fill: "#AE7A00",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6345 37.4844C54.9903 37.4844 55.5728 36.8531 57.3939 38.067C60.2354 39.9852 61.2308 43.7007 61.2308 46.0806C61.2308 50.8165 56.981 56.6926 52.3681 56.6926C47.7304 56.6926 44.4032 51.3982 44.064 46.76C44.064 46.5176 44.04 46.2982 44.04 46.0798C44.0383 41.3456 47.8991 37.4844 52.6345 37.4844Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5479 72.6484L67.8593 74.5915",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9189 72.6484L61.2296 74.5915",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0981 72.6484L37.4088 74.5915",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2568 56.3047H45.3498L46.9525 57.9076C49.3562 60.3115 53.2898 60.3115 55.6944 57.9076L57.2723 56.3047H58.3653C63.4648 56.3047 66.5486 58.6118 66.5486 63.7118V72.6481H36.0991V63.7118C36.0983 58.6118 39.1821 56.3047 44.2568 56.3047Z",
    fill: "#FFC949",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3233 35.5645C46.5879 35.5645 42.7271 39.4016 42.7271 44.1366C42.7271 48.8965 46.5879 55.0408 51.3233 55.0408C56.0587 55.0408 59.9195 48.8965 59.9195 44.1366C59.9195 39.4016 56.0587 35.5645 51.3233 35.5645Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7519 44.8409C47.8514 44.6712 51.2993 44.2823 54.9177 40.7364C54.9177 40.7364 56.2291 43.2379 59.9195 44.1366C59.9195 39.4008 56.0587 35.5645 51.3233 35.5645C46.5879 35.5645 42.7271 39.4016 42.7271 44.1366C42.7271 44.3799 42.7271 44.5984 42.7519 44.8409Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9189 72.6481V64.2695",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9189 44.1367C59.9189 44.1367 61.1088 46.1277 61.036 47.9011",
    stroke: "black",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9189 44.139C59.9189 44.139 61.1087 46.13 61.0359 47.9033C61.1576 47.272 61.2304 46.6645 61.2304 46.082C61.2304 43.7021 60.235 39.9865 57.3936 38.0684C58.9475 39.6224 59.9189 41.7839 59.9189 44.139Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5337 72.6481V64.2695",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5337 72.6484L43.8443 74.5915",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8478 17.3203L53.4746 22.5659L58.7197 22.3714V23.9015L54.0571 25.5044L51.8478 31.0413L49.6626 25.5044L45 23.9015V22.3714L50.2451 22.5659L51.8478 17.3203Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8478 15.498L53.4746 20.7685L58.7197 22.3705L53.4746 23.9734L51.8478 28.6365L50.2451 23.9734L45 22.3705L50.2451 20.7685L51.8478 15.498Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6626 25.5033V23.9004",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0327 25.5753V23.8027",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8477 31.0387V28.5371",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9785 70.1962V65.5332",
    stroke: "#171819",
    strokeWidth: 0.491511,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCabalGroupMode);
export default __webpack_public_path__ + "static/media/create-cabal-group-mode.9b5e304085b75dd3c43e590f75ecf8bd.svg";
export { ForwardRef as ReactComponent };